import { Box, DashboardModule } from '@domain-group/suit-theme'

import type { ProviderPriceListModel } from '@models/types'

import usePriceListProduct from '../../../hooks/usePriceListProduct'

import PriceListItem from './PriceListItem'

import styles from './styles.module.scss'

interface ProductProps {
  isMaster: boolean,
  providerPriceList: ProviderPriceListModel,
  serviceProductId: number,
}

const Product = (props: ProductProps) => {
  const { isMaster, providerPriceList, serviceProductId } = props

  const priceListProductPayload = usePriceListProduct({ isMaster, providerPriceList, serviceProductId })
  const {
    serviceProduct,
    visiblePriceListItems,
  } = priceListProductPayload

  return (
    // @ts-expect-error
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title={serviceProduct.title}>
      <Box className={styles.root} flexDirection="column">
        {visiblePriceListItems.map(priceListItem => (
          <PriceListItem
            key={priceListItem.id}
            providerPriceListItem={priceListItem}
            // @ts-expect-error TS2322
            serviceProduct={serviceProduct}
          />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default Product
